import { useContext } from 'react'

import { DocumentsManagementContext } from './context'

/**
 * Custom hook to use Documents Management Context
 * @throws Error if used outside of DocumentsManagementProvider
 */
export function useDocumentsManagement() {
  const context = useContext(DocumentsManagementContext)

  if (!context) {
    throw new Error('useDocumentsManagement must be used within DocumentsManagementProvider')
  }

  return context
}
